<template>
  <div class="share-page" :style="`display: ${page.button ? 'block' : 'inline-block'}`">
    <input
      id="share"
      :value="page.link"
      type="text"
      readonly
    />
    <div v-if="page.button" @click="photoShare($event)" class="share-button">
      <strong>Поделиться</strong>
      <i class="icon-share" />
    </div>
    <i v-else style="cursor:pointer;" @click="photoShare($event)" class="icon-share">Поделиться</i>
  </div>
</template>

<script>
export default {
  props: { page: { type: Object, default: () => ({ link: '', button: false }) } },
  methods: {
   photoShare(event) {
     	if (event.shiftKey) {
        const chatOpen = document.querySelector('.chat .create-message .input .input-message')
        if (chatOpen) {
          chatOpen.value += `[::link="${this.page.link}"::]${document.title}[::/link::]`
        }
      } else if (navigator.share) {
        navigator.share({
          title: document.title,
          text: 'Интересный контент, тебе обязательно нужно посмотреть!',
          url: this.page.link,
        })
        .then(() => console.log('Successfully share'))
        .catch((error) => console.log('Error sharing', error))
      } else {
        console.log('Share not supported on this browser, do it the old way.')
        const input = document.querySelector('#share')
        input.select()
        document.execCommand('copy')
        this.$store.commit('setError', { status: 'ok', msg: 'Ссылка скопирована' })
        setTimeout(() => this.$store.commit('clearError'), 1100)
      }
    }
  }
}
</script>

<style lang="stylus">
.share-page
  transition opacity .2s ease
  &:hover
    opacity .9
  .share-button
    width 100%
    margin-top 20px
    padding 5px
    color #fff
    background-color #8365bc
    text-align center
    cursor pointer
    .icon-share
      background-image url('/static_files/icons/upload-purple.svg')
      background-color rgba(255 255 255 .75)
    strong
      margin-right 10px
      vertical-align: super
  .icon-share
    display inline-block
    width 34px
    height 34px
    padding 7px
    border-radius 50%
    background rgba(255 255 255 .75) url('/static_files/icons/upload.svg') no-repeat center
    background-size 20px
    transition all .2s ease
    &:hover
      background-color rgba(255 255 255 1)
  #share
    position absolute
    top -9999px
    left 0
    opacity 0
</style>
